import assetPath from '/app/xinglets/upsell/products/src/assets/header-image.png';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')